
/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CategoryPredictionResource,
  ValidationError,
} from '../models';
import {
    CategoryPredictionResourceFromJSON,
    CategoryPredictionResourceToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface PredictCategoriesRequest {
    jobTitle: string;
}

/**
 * 
 */
export class CategoryPredictionsApi extends runtime.BaseAPI {

    /**
     * Predict categories
          */
    async predictCategoriesRaw(requestParameters: PredictCategoriesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<CategoryPredictionResource>>> {
        if (requestParameters['jobTitle'] == null) {
            throw new runtime.RequiredError(
                'jobTitle',
                'Required parameter "jobTitle" was null or undefined when calling predictCategories().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['jobTitle'] != null) {
            queryParameters['jobTitle'] = requestParameters['jobTitle'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<CategoryPredictionResource>>({
            path: `/search/api/categories/predictions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(CategoryPredictionResourceFromJSON);
        return response;
    }

    /**
     * Predict categories
          */
    async predictCategories(requestParameters: PredictCategoriesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<CategoryPredictionResource>> {
        const response = await this.predictCategoriesRaw(requestParameters, initOverrides);
        return response._data;
    }

}
